export enum BacktestSimMode {
  CLOSE_ONLY = 'CLOSE_ONLY',
  OHLC_PESSIMISTIC = 'OHLC_PESSIMISTIC',
  OHLC_BRIDGE = 'OHLC_BRIDGE',
}
